export default __webpack_public_path__ + "static/media/asc-v2.2562b281.png";